<script setup>
import fiveMixin from '@/composables/fiveMixin'
const { ...five } = fiveMixin()
const props = defineProps({
  ilganKor: String,
  keywords: Array,
})

const ilganChn = computed(()=>{
  let ilgan = props.ilganKor?.slice(0, 1)
  return five.getHanjaTxt2(ilgan)
})
const colorMap = {
  화: "five01",
  수: "five02",
  목: "five03",
  금: "five04",
  토: "five05",
}
const ilganColor = computed(() => {
  const ilgan = props.ilganKor?.slice(1, 2)
  return colorMap[ilgan] ?? "fiveDefault"
})

const classNames = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh']
</script>
<template>
  <div class="ilgan-bubble-wrapper">
    <div class="center-wrapper">
      <!-- 일간 -->
      <div 
        class="ilgan-bubble__ilgan"
        :class="ilganColor"
      >
        <div class="ilgan-bubble__ilgan-txt">
          <span class="ilgan-txt-chn">
            {{ ilganChn }}
          </span>
          <span class="ilgan-txt-kor">
            {{ ilganKor }}
          </span>
        </div>
      </div>

      <div
        v-for="(keyword, idx) in keywords"
        :key="`keyword-${idx}`"
        :class="['ilgan-bubble__keyword', classNames[idx] || '']"
      >
        <span class="ilgan-bubble__keyword-txt">{{ keyword }}</span>
      </div>
    </div>

  </div>
</template>